import { Typography, Slider } from '@mui/material';
import { useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import { LibraryVideo } from '../videos.domain';
import { VideoThumbnail } from './VideoPanel/VideoThumbnail';

type VideoThumbnailSelectProps = {
  media: LibraryVideo;
  onChange: (timeInSeconds: number) => void;
};

function VideoThumbnailSelect(props: VideoThumbnailSelectProps) {
  const videoSrc = props.media.videoSrc;
  const playerRef = useRef<ReactPlayer>(null);
  const [metadata, setMetadata] = useState({ duration: 0 });
  const [sliderValue, setSliderValue] = useState(0);
  const handleSliderChange = (
    _event: Event | null,
    newValue: number | number[],
  ) => {
    const value = newValue as number;
    setSliderValue(value);
    if (playerRef?.current) {
      playerRef.current.seekTo(value);
      props.onChange(value);
    }
  };

  const framesCount = 10; // NOTE: only displaying for s3 vertical videos
  const frameWidth = 747 / framesCount;
  const frameHeight = (16 / 9) * frameWidth;

  const displayPreview = !videoSrc.includes('.m3u8');

  return (
    <div>
      <div className="flex justify-center mb-2">
        <Typography variant="h4">{props.media.name}</Typography>
      </div>
      <div className="flex justify-center bg-black">
        <ReactPlayer
          onDuration={(duration) => setMetadata({ duration })}
          ref={playerRef}
          playing={false}
          seconds={sliderValue}
          playsinline
          height={300}
          url={videoSrc}
          config={{
            file: {
              attributes: {
                poster: props.media.poster,
              },
            },
          }}
          style={{
            borderRadius: '6px',
            overflow: 'hidden',
          }}
        />
      </div>

      <div className="mt-5">
        <Typography variant="h5" className="font-semibold">
          Select a still to be used as the video thumbnail.
        </Typography>
        <Typography variant="body1">
          A good still stands out and draws viewers’ attention to the exercise.
        </Typography>
      </div>
      {displayPreview ? (
        <div className="flex mt-4 max-height-[100px]">
          {Array.from({ length: framesCount }).map((_, i) => {
            // -1 is needed to first frame be at time 0 and last one at the end of the video
            const time = (metadata.duration / (framesCount - 1)) * i;
            return (
              <div
                key={i}
                onClick={() => handleSliderChange(null, time)}
                className="cursor-pointer overflow-hidden"
                style={{
                  width: frameWidth,
                  maxHeight: frameHeight,
                }}
              >
                <VideoThumbnail
                  videoUrl={videoSrc}
                  snapshotAtTime={time}
                  cors={false}
                />
              </div>
            );
          })}
        </div>
      ) : null}
      <Slider
        value={sliderValue}
        max={metadata.duration}
        step={0.01}
        onChange={handleSliderChange}
      />
    </div>
  );
}

export default VideoThumbnailSelect;
